import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NFormComponent } from '@pebula/nform';
import { InspectorModel } from '../../inspector-form-model';

const FIND_FILE = {
  label: 'Find file',
  icon: 'gps_fixed',
};
const TRY_AGAIN = {
  label: 'Try again',
  icon: 'search',
};

@Component({
  selector: 'sg-inspector-shortcut-search',
  templateUrl: './inspector-shortcut-search.component.html',
  styleUrls: ['./inspector-shortcut-search.component.scss'],
  standalone: false,
})
export class SgInspectorShortcutSearchComponent implements OnChanges {
  @Input() inspectorFormModel: InspectorModel;
  @Input() failedToFind: boolean;
  @Output() onClickFindFile = new EventEmitter<void>();
  @Output() onClickSkip = new EventEmitter<void>();
  @ViewChild('shortcutSearchForm', { read: NFormComponent, static: true }) shortcutSearchForm: NFormComponent;

  findFileButton = FIND_FILE;
  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['failedToFind']?.currentValue === true) {
      this.findFileButton = TRY_AGAIN;
    } else {
      this.findFileButton = FIND_FILE;
    }
  }

  findFile() {
    this.inspectorFormModel.fileName = this.shortcutSearchForm.form.controls['fileName'].value;
    this.onClickFindFile.emit();
  }

  skipToExpandedSearch() {
    this.findFileButton = FIND_FILE;
    this.inspectorFormModel.fileName = null;
    this.onClickSkip.emit();
  }
}
